/**
 * Given a string, it hashes it and returns the first 8 characters
 * @param {string} value - The ordinal value.
 * @returns {string} - Either the original value, or 0 if the `indexOf` is -1.
 */
export default function ordinalSafetyCheck(ordinal) {
  return -1 !== ordinal ? ordinal : 0;
}



// WEBPACK FOOTER //
// ./app/services/ordinalSafetyCheck.js